import { ObjectMapper } from "json-object-mapper";
import { InsightModel } from "./insight.model";

export class InsightTurnOverModel extends InsightModel {
  static create(input: any): InsightTurnOverModel {
    return ObjectMapper.deserialize<InsightTurnOverModel>(InsightTurnOverModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}